import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchCirculars } from '@/lib/api';
import type { Circular } from '@/lib/types';

type State = { status: 'loading' | 'error' | 'success'; data: Circular[] };

export function useCirculars() {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<State>({ status: 'loading', data: [] });
  const [params] = useSearchParams();
  // Dev only: ?state=loading|empty|error forces a state so each one can be
  // reviewed by eye. Stripped from production builds.
  const override = import.meta.env.DEV ? params.get('state') : null;

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', data: [] });
    const run: Promise<Circular[]> =
      override === 'loading'
        ? new Promise(() => {})
        : override === 'error'
          ? Promise.reject(new Error('forced by ?state=error'))
          : override === 'empty'
            ? Promise.resolve([])
            : fetchCirculars();
    run.then(
      (data) => !cancelled && setState({ status: 'success', data }),
      () => !cancelled && setState({ status: 'error', data: [] }),
    );
    return () => {
      cancelled = true;
    };
  }, [attempt, override]);

  return { ...state, retry: () => setAttempt((a) => a + 1) };
}
